import { InitialState } from "./state.interface";

export const initialCurrencyState: InitialState = {
    currencyError: null,
    currencyLoading: false,
    data: null
}